module.exports = __webpack_public_path__ + "static/japan12-7d190ffac15a4f5998d7743d4e19d8ff.jpg";